export default "__VITE_ASSET__BM5kxnE7__"